module.exports = __webpack_public_path__ + "img/google-play.14580db2.png";